import { Select } from "antd";

const { Option } = Select;

export const ServiciosSelect = ({ value, onChange, arr, label }) => {
  return (
    <>
      <div className="labelImput">{label}</div>
      <Select
        value={value}
        name="servicioID"
        onChange={onChange}
        style={{ width: "100%" }}
        placeholder="Selecciona Servicio"
      >
        {arr.map((a, i) => (
          <Option key={i} value={a.id}>
            {a.nombre}
          </Option>
        ))}
      </Select>
    </>
  );
};
